
export enum NotificationEventStatus {
  Success = 1,
  Fail = 2,
  Doing = 3
}

export enum NotificationItemEventType {
  Recharge = 2,
  Withdraw = 3,
  Proxy = 4,
  VIP = 5,
  Rummy = 6,
  CumulativeDeposit = 7 // 累充转盘
}

export enum NotificationEventType {
  Platform = 1,
  Recharge = 2,
  Withdraw = 3,
  Proxy = 4,
  VIP = 5,
  Rummy = 6,
  CumulativeDeposit = 7, // 累充转盘
  TransferPackage = 8, // 转移包
  Compensation = 9, // 补偿
  AggregationMsg = 99 // 聚合消息（多条消息合并成一条消息，前端展示消息数量）
}

export enum NotificationType {
  Platform = 1,
  Personal = 2
}

export enum CurrencyType {
  BRL = 'BRL',
  INR = 'INR',
  USDT = 'USDT'
}

// 卡片标题颜色枚举(提现和充值成功/失败时会显示不同的颜色)
export enum MsgCardTitleColor {
  Default = '',
  Success = 'text-accent-green',
  Fail = 'text-accent-red'
}

// 数据埋点-只上报代理、VIP、平台消息、累充、rummy
export const TRACK_MSG_TYPES = [
  NotificationEventType.Proxy,
  NotificationEventType.VIP,
  NotificationEventType.Platform,
  NotificationEventType.Rummy,
  NotificationEventType.CumulativeDeposit
];
// 数据埋点上报的事件类型的值
export const TRACK_MSG_TYPE_VALUE = {
  [NotificationEventType.Platform]: 'Platform',
  [NotificationEventType.Proxy]: 'Referral',
  [NotificationEventType.VIP]: 'VIP',
  [NotificationEventType.Rummy]: 'Rummy Tournament',
  [NotificationEventType.CumulativeDeposit]: 'Deposit & Spin'
};
